import { DateTime } from 'luxon'
import { defineStore } from 'pinia'

import ScheduleRepository from '@/app/repositories/schedule-repository'
import { Schedule } from '@/common/models/data/dashboard/schedule/schedule'

const useScheduleStore = defineStore('schedule', {
    state: () => ({
        schedule: {} as Record<string, Array<Schedule>>
    }),
    actions: {
        async load (): Promise<void> {
            this.schedule = await ScheduleRepository.all()
        }
    },
    getters: {
        currentDay (): string {
            // "- 1"  here because weekday is in the ISO format
            // which is in range from 1 to 7 where 7 is sunday
            return this.dayKeys[DateTime.local().weekday - 1]
        },
        currentProgramme (state): Schedule | undefined {
            const dailySchedule = state.schedule[this.currentDay]

            if (dailySchedule) {
                const results = dailySchedule.filter(item => {
                    return item.started && (item.notFinished || item.isOverlapping)
                })

                if (results.length > 0) {
                    return results[0]
                }

                return undefined
            }

            return undefined
        },
        dayKeys: (state): Array<string> => {
            return Object.keys(state.schedule)
        }
    }
})

export {
    useScheduleStore
}
